import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ConversionTable } from '../models/conversion-table';
import { ConversionTableRow } from '../models/conversion-table-row';
import { ConversionTableImportData } from '../models/conversion-table-import-data';

import { DownloaderService } from '../../shared/download/downloader.service';
import { FileHttpService } from '../../shared/http/file-http.service';
import { JsonHttpService } from '../../shared/http/json-http.service';

import { ImportResult } from '../../shared/import-export/models/import-result';

@Injectable({
    providedIn: 'root'
})
export class ConversionTableService {

    constructor(private httpService: JsonHttpService, private downloaderServicer: DownloaderService, private fileHttpService: FileHttpService) { }

    getConversionTablesLight(partnerId: number): Promise<ConversionTable[]> {
        const options = { params: new HttpParams().set('partnerId', `${partnerId}`) };
        return this.httpService.get('/api/partners/conversions/get-conversion-tables-light', options).toPromise();
    }

    getFullConversionTable(conversionTableId: number, partnerId?: number, includeRowsFromOtherPartners: boolean = false): Promise<ConversionTable> {
        const options = {
            params: new HttpParams()
                .set('conversionTableId', `${conversionTableId}`)
                .set('partnerId', `${partnerId}`)
                .set('includeRowsFromOtherPartners', `${!!includeRowsFromOtherPartners}`)
        };
        return this.httpService.get('/api/partners/conversions/get-full-conversion-table', options).toPromise();
    }

    saveConversionTableStructure(conversionTable: ConversionTable): Promise<ConversionTable> {
        return this.httpService.post('/api/partners/conversions/save-conversion-table-structure', conversionTable).toPromise();
    }

    deleteConversionTable(conversionTableId: number): Promise<void> {
        const options = { params: new HttpParams().set('conversionTableId', `${conversionTableId}`) };
        return this.httpService.post('/api/partners/conversions/delete-conversion-table', null, options).toPromise();
    }

    saveRow(row: ConversionTableRow): Promise<ConversionTableRow> {
        return this.httpService.post('/api/partners/conversions/save-conversion-table-row', row).toPromise();
    }

    deleteRow(rowId: number): Promise<void> {
        const options = { params: new HttpParams().set('rowId', `${rowId}`) };
        return this.httpService.post('/api/partners/conversions/delete-conversion-table-row', null, options).toPromise();
    }

    parseDataToImport(dataToImport: ConversionTableImportData): Promise<ConversionTableRow[]> {
        return this.httpService.post('/api/partners/conversions/import-data', dataToImport).toPromise();
    }

    isConversionTableNameAvailable(conversionTableName: string): Promise<boolean> {
        const options = { params: new HttpParams().set('conversionTableName', `${conversionTableName}`) };
        return this.httpService.get('/api/partners/conversions/is-conversion-table-name-available', options).toPromise();
    }

    async exportConversionTable(conversionTableId: number): Promise<void> {
        const options = { params: new HttpParams().set('conversionTableId', `${conversionTableId}`) };
        const token = await this.httpService.get('/api/partners/conversions/export/export-conversion-table', options).toPromise();
        this.downloaderServicer.downloadFile(token);
    }

    importConversionTable(partnerId: number, file: File, importOption: number): Promise<ImportResult> {
        const options = {
            params: new HttpParams()
                .set('importOption', `${importOption}`)
                .set('partnerId', `${partnerId}`)
        };
        return this.fileHttpService.upload<ImportResult>('/api/partners/conversions/export/upload-import-table', [file], options);
    }
}
